module.exports = __webpack_public_path__ + "static/media/platformMob.01d67b19.jpeg";